import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUserGroups } from 'actions';
import { getUsers, setUsers } from 'actions/userAction';
import { Table, Button, Modal, Form, Alert, Spinner } from 'react-bootstrap';

class UserList extends Component {
  state = {
    showModal: false,
    isEdit: false,
    formData: {
      username: '',
      full_name: '',
      group_ids: [],
      password: '',
      is_active: true
    },
    error: null
  };

  componentDidMount() {
    this.props.getUserGroups();
    this.props.getUsers();
  }

  handleShowModal = (user = null) => {
    if (user) {
      this.setState({
        showModal: true,
        isEdit: true,
        formData: {
          _id: user._id,
          username: user.username || '',
          full_name: user.full_name || '',
          group_ids: user.group_ids || [],
          password: '', // Không show password cũ
          is_active: user.is_active
        },
        error: null
      });
    } else {
      this.setState({
        showModal: true,
        isEdit: false,
        formData: {
          username: '',
          full_name: '',
          group_ids: [],
          password: process.env.REACT_APP_DEFAULT_PASSWORD,
          is_active: true
        },
        error: null
      });
    }
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, error: null });
  };

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState(prev => ({
      formData: {
        ...prev.formData,
        [name]: type === 'checkbox' ? checked : value
      }
    }));
  };

  handleGroupCheckbox = (groupId) => {
    this.setState(prev => {
      const group_ids = prev.formData.group_ids.includes(groupId)
        ? prev.formData.group_ids.filter(id => id !== groupId)
        : [...prev.formData.group_ids, groupId];
      return {
        formData: {
          ...prev.formData,
          group_ids
        }
      };
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { isEdit, formData } = this.state;
    try {
      await this.props.setUsers([formData]);
      await this.props.getUsers();
      alert(isEdit ? 'User updated!' : 'User created!');
    } catch (err) {
      alert('Save failed!');
    }
    this.handleCloseModal();
  };

  handleResetPassword = async (user) => {
    if (window.confirm(`Are you sure you want to reset password for user ${user.username}?`)) {
      try {
        const resetData = {
          ...user,
          password: process.env.REACT_APP_DEFAULT_PASSWORD,
          status: 'NEED_CHANGE_PASSWORD'
        };
        await this.props.setUsers([resetData]);
        await this.props.getUsers();
        alert(`Password has been reset to default: ${process.env.REACT_APP_DEFAULT_PASSWORD}`);
      } catch (err) {
        alert('Reset password failed!');
      }
    }
  };

  render() {
    const { userGroups, users, loading } = this.props;
    const { showModal, formData, error, isEdit } = this.state;
    // Helper: map id sang tên
    const groupIdToName = {};
    userGroups.forEach(g => {
      groupIdToName[g._id] = g.name || g.group_name;
    });
    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>User List</h3>
          <Button variant="primary" onClick={() => this.handleShowModal()}>Create New User</Button>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Username</th>
              <th>Full Name</th>
              <th>Groups</th>
              <th>Active</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} className="text-center"><Spinner animation="border" size="sm" /></td></tr>
            ) : users.length === 0 ? (
              <tr><td colSpan={5} className="text-center">No users</td></tr>
            ) : users.map((u, idx) => (
              <tr key={u._id || idx}>
                <td>{u.username}</td>
                <td>{u.full_name}</td>
                <td>{(u.group_ids || []).map(id => groupIdToName[id]).filter(Boolean).join(', ')}</td>
                <td>{u.is_active ? 'Yes' : 'No'}</td>
                <td>
                  <Button size="sm" variant="info" className="me-2" onClick={() => this.handleShowModal(u)}>Edit</Button>
                  <Button size="sm" variant="warning" onClick={() => this.handleResetPassword(u)}>Reset Password</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Modal show={showModal} onHide={this.handleCloseModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEdit ? 'Edit User' : 'Create New User'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={this.handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  name="username"
                  value={formData.username}
                  onChange={this.handleChange}
                  required
                  disabled={isEdit}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  name="full_name"
                  value={formData.full_name}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Groups</Form.Label>
                <div>
                  {userGroups.map(g => (
                    <Form.Check
                      key={g._id}
                      type="checkbox"
                      label={g.name || g.group_name}
                      checked={formData.group_ids.includes(g._id)}
                      onChange={() => this.handleGroupCheckbox(g._id)}
                    />
                  ))}
                </div>
              </Form.Group>
              {!isEdit && (
                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="text"
                    value={`Default password: ${process.env.REACT_APP_DEFAULT_PASSWORD}`}
                    disabled
                    readOnly
                  />
                </Form.Group>
              )}
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Active"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Button type="submit" variant="primary">{isEdit ? 'Save' : 'Create'}</Button>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userGroups: state.userGroupReducer.userGroups || [],
  users: state.userReducer.users || [],
  loading: state.userReducer.loading
});

export default connect(mapStateToProps, { getUserGroups, getUsers, setUsers })(UserList); 